import React from 'react';
import team1 from '../Assets/imgs/md.jpg';
import team2 from '../Assets/imgs/account.jpg';
import team3 from '../Assets/imgs/logistics.jpg';
import team4 from '../Assets/imgs/sales.png';
import team5 from '../Assets/imgs/hrm.jpg';
import team6 from '../Assets/imgs/hod.jpg';
import team7 from '../Assets/imgs/mis.jpg';
import team8 from '../Assets/imgs/pratik.png';
import team9 from '../Assets/imgs/sd.JPG';
import teamwork from '../Assets/imgs/team_work.jpg';
import warehouse from '../Assets/imgs/warehouse.jpg';

const teamMembers = [
  { name: 'Rishav Agrawal', position: 'Managing Director', image: team1 },
  { name: 'Teknath Pathak', position: 'Account Head', image: team2 },
  { name: 'Manoj Khatiwada', position: 'Logistics Head', image: team3 },
  { name: 'Kaushal Raj Tripathi', position: 'Area Sales Manager', image: team4 },
  { name: 'Pratikshya Koirala', position: 'Human Resource Manager', image: team5 },
  { name: 'Sunita Chukkan', position: 'Head of Department', image: team6 },
  { name: 'Sadeem Tamrakar', position: 'MIS Head', image: team7 },
  { name: 'Pratik Dhewaju', position: 'Area Sales Manager', image: team8 },
  { name: 'Sankalpa Dahal', position: 'MIS Executive', image: team9 },
];

export default function AboutSection() {
  return (
    <section id="about" className="font-poppins py-16 px-4 max-w-7xl mx-auto">
      <h3 className="text-4xl font-semibold mb-4 text-center text-gray-900">
        Who We Are
      </h3>

      <p className="mb-12 text-gray-700 text-center max-w-3xl mx-auto text-lg">
        We are passionate about connecting communities through the latest mobile technologies and providing unparalleled support and logistics solutions. As a national distributor, our brands include Infinix and OnePlus — with Infinix delivered in the central region of Nepal, and OnePlus delivered nationwide along with an authorized OnePlus service center
      </p>
      {/* Team Members Grid Carousel */}
      <h4 className="text-3xl font-semibold text-center mb-10 text-gray-800">
        Meet Our Team
      </h4>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 px-4">
        {teamMembers.map((member, index) => (
          <div
            key={index}
            className="bg-white rounded-xl shadow-md p-6 flex flex-col items-center text-center hover:shadow-lg transition"
          >
            <img
              src={member.image}
              alt={member.name}
              className="w-52 h-52 object-cover rounded-full mb-4"
            />
            <h5 className="text-xl font-medium text-gray-900">{member.name}</h5>
            <p className="[color:#00AEEA]">{member.position}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

// import React from 'react';

// // If you have local images, import them like this:
// // import image1 from '../Assets/imgs/team_work.jpg';
// // import image2 from '../Assets/imgs/warehouse.jpg';

// export default function AboutSection() {
//   return (
//     <section id="about" className="py-16 px-4 max-w-4xl mx-auto text-center">
//       <h3 className="text-3xl font-semibold mb-4">Who We Are</h3>

//       <p className="mb-8 text-gray-700">
//         We are passionate about connecting communities through the latest mobile technologies and providing unparalleled support and logistics solutions.
//       </p>

//       <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
//         <div className="sm:w-1/2">
//           <img
//             src="/path/to/your/image1.jpg"
//             alt="Our team working"
//             className="w-full h-auto rounded-lg shadow-lg"
//           />
//         </div>

//         <div className="sm:w-1/2">
//           <img
//             src="/path/to/your/image2.jpg"
//             alt="Distribution warehouse"
//             className="w-full h-auto rounded-lg shadow-lg"
//           />
//         </div>
//       </div>
//     </section>
//   );
// }
